import request from '@/config/axios'

// 经营看板 VO
export interface StatisticsVO {
  id?: string | number
  shopId: string | number
  statDate: string
  totalRooms: number
  occupiedRooms: number
  availableRooms: number
  checkInCount: number
  checkOutCount: number
  currentOccupancy: number
  newBookingCount: number
  cancelCount: number
  revenue: number
  occupancyRate: number
  cleaningCount: number
  maintenanceCount: number
  alertCount: number
  remark?: string
  createTime?: Date
}

// 获取经营统计分页
export const getStatisticsPage = (params: any) => {
  return request.get({ url: '/hotel/statistics/page', params })
}

// 获取经营统计详情
export const getStatistics = (id: string | number) => {
  return request.get({ url: '/hotel/statistics/get?id=' + id })
}

// 创建经营统计
export const createStatistics = (data: StatisticsVO) => {
  return request.post({ url: '/hotel/statistics/create', data })
}

// 更新经营统计
export const updateStatistics = (data: StatisticsVO) => {
  return request.put({ url: '/hotel/statistics/update', data })
}

// 删除经营统计
export const deleteStatistics = (id: string | number) => {
  return request.delete({ url: '/hotel/statistics/delete?id=' + id })
}

// 批量删除经营统计
export const deleteStatisticsList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/statistics/delete-list?ids=' + ids.join(',') })
}

// 获取统计概览(看板)
export const getStatisticsOverview = (params: any) => {
  return request.get({ url: '/hotel/statistics/overview', params })
}

// 获取趋势数据
export const getStatisticsTrend = (params: any) => {
  return request.get({ url: '/hotel/statistics/trend', params })
}
